import { Outlet } from 'react-router'
import { MainLayout } from './MainLayout'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { useAccountSettings } from '@/hooks/useAccountSettings'
import { useLanguageSync } from '@/hooks/useLanguageSync'

export function ProtectedLayout() {
  const { data: accountSettings } = useAccountSettings()
  // B-026a — apply the account's language preference once it loads.
  useLanguageSync()
  // While accountSettings is undefined the title stays at the bare 'FlowRent'
  // default from index.html. Once loaded, it becomes '<name> | FlowRent'.
  useDocumentTitle(accountSettings ? `${accountSettings.name} | FlowRent` : '')

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}
